(function () {
  'use strict';

  if (document.documentElement.classList.contains('shopify-design-mode')) return;

  function protectImages(root) {
    (root || document).querySelectorAll('img').forEach(function (image) {
      image.draggable = false;
      image.setAttribute('draggable', 'false');
    });
  }

  document.addEventListener('dragstart', function (event) {
    if (event.target instanceof Element && event.target.closest('img, picture')) {
      event.preventDefault();
    }
  });

  document.addEventListener('contextmenu', function (event) {
    if (event.target instanceof Element && event.target.closest('img, picture, [style*="background-image"]')) {
      event.preventDefault();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { protectImages(document); }, { once: true });
  } else {
    protectImages(document);
  }

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node instanceof Element) {
          if (node.matches('img')) {
            node.draggable = false;
            node.setAttribute('draggable', 'false');
          }
          protectImages(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
